import { VerificationState } from "backend/datainput";
import { t } from "i18next";

export const isNotEmpty = (state: VerificationState) => {
  if (!state.field.value) {
    return {
      success: false,
      errorMessages: [t("workflowinput.form.errors.Value can not be empty")],
    };
  }
};

const isNum = (s: string) => !isNaN(+s) && isFinite(+s) && !/e/i.test(s);

export const isNumber = (state: VerificationState) => {
  if (!isNum(state.field.value)) {
    return {
      success: false,
      errorMessages: [t("workflowinput.form.errors.Value must be number")],
    };
  }
};
